// dependencies
import { Child } from 'pym.js';

// polyfills
import './utils/polyfills';

// graphic
import initGraphic from './graphic';

// styles
import './styles/index.scss';

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.clear();
}

let app = null;

// pym invokes this on first paint and on every width change. The stepper keeps
// its own state, so we build the DOM once and only re-render the map (which is
// width-dependent) on subsequent calls.
function draw() {
  const container = document.getElementById('graphic');
  if (!container) return;

  if (!app) {
    app = initGraphic(container);
  } else {
    app.resize();
  }

  if (window.pymChild) window.pymChild.sendHeight();
}

window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = () => {
  if (!app) draw();
  window.pymChild.sendHeight();
};
